const initialState = [];

export const supportLanguages = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SUPPORT_LANGUAGES_DATA':
      return action.payload;
    default:
      return state;
  }
};
